import React from 'react'
import { StyleSheet, Text, View } from 'react-native'

interface DisabledButtonProps {
  text: string
}

const DisabledButton = ({ text }: DisabledButtonProps) => {
  return (
    <View style={styles.disabledButton}>
      <Text style={styles.buttonText}>{text}</Text>
    </View>
  )
}

export default DisabledButton

const styles = StyleSheet.create({
  buttonText: {
    color: '#dddddd',
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
    textTransform: 'uppercase'
  },
  disabledButton: {
    backgroundColor: '#888888',
    borderRadius: 4,
    padding: 10
  }
})
